<template>
  <v-select
      v-model="item"
      :items="items"
      :item-text="formatCaja"
      item-value="id"
      :label="label"
      :loading="loading"
      :clearable="clearable"
      outlined
      dense
  />
</template>

<script>
import dayjs from "dayjs";
import AgenciaObjetivoProvider from "@/modules/cobrox/providers/AgenciaObjetivoProvider";

const parseBackendDate = value => {
  const raw = String(value || '')
  return /^-?\d+$/.test(raw) ? Number(raw) : value
}

export default {
  name: "CajaMensualObjetivoCombobox",
  props: {
    value: {type: String},
    label: {type: String, default: 'Caja mensual'},
    clearable: {type: Boolean, default: false},
    autoSelectLatest: {type: Boolean, default: true}
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    formatCaja(item) {
      const estado = item.cerrada ? 'Cerrada' : 'Abierta'
      return `${dayjs(parseBackendDate(item.fecha)).format('MM/YYYY')} - ${estado}`
    },
    fetch() {
      this.loading = true
      AgenciaObjetivoProvider.fetchCajaMensualObjetivosImport()
          .then(r => {
            this.items = r.data.fetchCajaMensualObjetivosImport || []
            if (this.autoSelectLatest && !this.value && this.items.length > 0) {
              this.$emit('input', this.items[0].id)
            }
            this.$emit('loaded', this.items)
          })
          .catch(e => {
            this.$emit('error', e)
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>
